import { CarrinhoContextProvider } from 'context/CarrinhoContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRoutes from 'routes';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CarrinhoContextProvider>
      <AppRoutes />
    </CarrinhoContextProvider>
  </React.StrictMode>
);
